import * as React from "react";

import TranslationMapper from "i18n/mapper";
import LanguageProvider from "providers/languageProvider";

import IconImageNotFoundActive from "../../assets/img/image-not-found-active.svg";
import IconImageNotFoundInactive from "../../assets/img/image-not-found-inactive.svg";

import INotificationCategoryItemProps from "./interfaces/INotificationCategoryItemProps";

export default class NotificationCategoryItem extends React.Component<INotificationCategoryItemProps> {
  public constructor(props: INotificationCategoryItemProps) {
    super(props);
    this.onClick = this.onClick.bind(this);
    this.imageSrc = this.imageSrc.bind(this);
  }

  public imageSrc(): string {
    if (this.props.active) {
      return this.props.notificationCategory.activeImageExists
        ? `${this.props.imageUri}?${new Date().getTime()}`
        : IconImageNotFoundActive;
    }
    return this.props.notificationCategory.inactiveImageExists
      ? `${this.props.imageUri}?${new Date().getTime()}`
      : IconImageNotFoundInactive;
  }

  public render(): JSX.Element {
    const name = this.props.name !== "" ? this.props.name : LanguageProvider.t(TranslationMapper.images.namenotfound);
    return (
      <button
        onClick={this.onClick}
        type="button"
        title={name}
        className={`btn btn--image-label mb-3 ${this.props.active ? "active" : "inactive"}`}
      >
        {/* Date is added to prevent caching */}
        <img src={this.imageSrc()} alt="" />
        <div>{name}</div>
      </button>
    );
  }

  private onClick(): void {
    if (this.props.selectingDisabled) {
      return;
    }

    this.props.onItemClick(this.props.notificationCategory);
  }
}
